<script setup>
  import { reactive, ref } from 'vue';

  import { authService } from '@/services/auth-service.js';
  import { useRoute } from 'vue-router';

  const route = useRoute();

  const form = reactive({
    new_password: '',
    password: ''
  })



const loading = ref(false)
const error = ref(null)
const success = ref(null)


  // Token is delivered in the URL fragment (#token=...) so it doesn't end
  // up in server logs or Referer headers. Fall back to the legacy query
  // param so existing reset links in flight still work.
  const tokenFromHash = (() => {
    const hash = (route.hash || '').replace(/^#/, '');
    return new URLSearchParams(hash).get('token');
  })();
  const token = tokenFromHash || route.query.token;

const resetPasswordRequest = async () => {
  try {
    loading.value = true
    error.value = null

    if(form.password===form.new_password){
      const result = await authService.reset_pass(form.password, token);
      if(result.data && result.data.status){
        success.value = 'password reset successfully'
        setTimeout(() => {
          window.location.href = '/login'
        }, 1500);
      }
    }else{
      error.value = 'he password does not match'
    }

  } catch (e) {
    error.value = e.response?.data?.message || 'Password reset error'
  } finally {
    loading.value = false
  }
}


</script>

<template>
    <div class="page">
      <div class="wrapper">


        <div class="card-form">

          <div class="logo">
            <div class="my-4" id="logo-image"></div>
          </div>
          <div v-if="error" class="alert alert-error">
            {{ error }}
          </div>

          <div v-if="success" class="alert alert-success">
            {{ success }}
          </div>

          <form @submit.prevent="resetPasswordRequest" class="p-4">
          <div class="input-group">
            <input type="password" v-model="form.password" placeholder="Password">
          </div>

            <div class="input-group">
              <input type="password" v-model="form.new_password" placeholder="Confirm password">
            </div>

          <button class="btn-button" :disabled="loading">
            {{ loading ? 'Loading...' : 'Reset password' }}
          </button>
          </form>

        </div>

        <div class="footer">
          Impact Journals, LLC
        </div>

      </div>
    </div>

</template>

